/**
 * English translations - Main entry
 */

import common from './common'
import nav from './nav'
import home from './home'
import about from './about'
import industrySolutions from './industrySolutions'
import coreService from './coreService'
import caseStudies from './caseStudies'
import resourceCenter from './resourceCenter'
import customerSupport from './customerSupport'
import contact from './contact'
import footer from './footer'

export default {
  common,
  nav,
  home,
  about,
  industrySolutions,
  coreService,
  caseStudies,
  resourceCenter,
  customerSupport,
  contact,
  footer
}

